/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot} from '@angular/router';
import {Observable, BehaviorSubject} from 'rxjs';
import {ScreensManagerDeps, ScreensManager} from '../../../components/sections/service/screen-manager.class';
import {Screen} from '../../../components/sections/service/screen.class';

interface Parameters {
    index: string;
}

@Injectable()
export class RepeatableScreensManagerDeps {
    constructor(readonly router: Router, readonly smgm: ScreensManagerDeps) {
    }
}

@Injectable()
export abstract class RepeatableScreensManager extends ScreensManager {

    totalItems: number;

    private _itemIndexSubject$ = new BehaviorSubject<number>(undefined as any);

    get itemIndex() { return this._itemIndexSubject$.getValue(); }

    set itemIndex(value: number) { this._itemIndexSubject$.next(value); }

    screenChange$: Observable<boolean>;

    protected get _router(): Router { return this._rsmm.router; }

    constructor(private readonly _rsmm: RepeatableScreensManagerDeps) {
        super(_rsmm.smgm);
        this.screenChange$ = this._itemIndexSubject$.distinctUntilChanged().map(() => true).publishReplay(1).refCount();
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        this.itemIndex = +(route.params as Parameters).index;
    }

    hasPreviousScreen(): boolean {
        return this.itemIndex > 1;
    }

    hasNextScreen(): boolean {
        return this.itemIndex < this.totalItems + 1;
    }

    navigateToPreviousScreen(): Observable<boolean> {
        return this._navigate(this.itemIndex - 1);
    }

    navigateToNextScreen(): Observable<boolean> {
        return this._navigate(this.itemIndex + 1);
    }

    navigateToFirstScreen(): Observable<boolean> {
        return this._navigate(1);
    }

    navigateToLastScreen(): Observable<boolean> {
        return this._navigate(this.totalItems + 1);
    }

    protected _navigate(index: number): Observable<boolean> {
        return Observable.fromPromise(this._rsmm.router.navigateByUrl(this._pathFromRootUsing({index: index})));
    }

    protected _doRefresh(): Observable<any> {
        return this._countEntries().do(value => this.totalItems = value);
    }

    protected abstract _countEntries(): Observable<number>;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/step/repeatable-screen-manager.class.ts